export interface PriceFormData {
  date: string | Date | null;
  outlet: string | null;
  outletShortName: string | null;
  productId: string | null;
  productCode: string | null;
  price: string | number | null;
  isActive: boolean;
}

export interface FormErrors {
  [key: string]: string;
}

export const validateForm = (data: PriceFormData): FormErrors => {
  const newErrors: FormErrors = {};

  if (!data.date) {
    newErrors.date = "Date is required.";
  }

  if (!data.outlet) {
    newErrors.outlet = "Outlet is required.";
  }

  if (!data.outletShortName) {
    newErrors.outletShortName = "Outlet short name is required.";
  }

  if (!data.productId) {
    newErrors.productId = "Product ID is required.";
  }

  if (!data.productCode) {
    newErrors.productCode = "Product code is required.";
  }

  if (data.price === "" || data.price === null || data.price === undefined) {
    newErrors.price = "Price is required.";
  } else if (isNaN(Number(data.price))) {
    newErrors.price = "Price must be a number.";
  } else if (Number(data.price) < 0) {
    newErrors.price = "Price cannot be negative.";
  }

  return newErrors;
};
